import { render, staticRenderFns } from "./TermsPromotionView.vue?vue&type=template&id=7f2a8acf&scoped=true&"
import script from "./TermsPromotionView.vue?vue&type=script&lang=js&"
export * from "./TermsPromotionView.vue?vue&type=script&lang=js&"
import style0 from "./TermsPromotionView.vue?vue&type=style&index=0&id=7f2a8acf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a8acf",
  null
  
)

export default component.exports